import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { devicesApi } from '../services/devicesApi';

const DEVICES_KEY = ['users', 'me', 'devices'] as const;

export const useDevices = () =>
  useQuery({
    queryKey: DEVICES_KEY,
    queryFn: ({ signal }) => devicesApi.getMyDevices(signal),
  });

export const useDeleteDevice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: devicesApi.deleteDevice,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: DEVICES_KEY });
    },
  });
};
